import { useLayoutEffect, useRef, useState } from "react";

export const useOverflow = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;

    const naturalWidth = Array.from(el.children).reduce((sum, child) => sum + (child as HTMLElement).offsetWidth, 0);

    const check = () => setIsOverflowing(el.clientWidth < naturalWidth);

    const observer = new ResizeObserver(check);
    observer.observe(el);
    check();
    return () => observer.disconnect();
  }, []);

  return { ref, isOverflowing };
};
